import { useEffect } from "react";
import './SaveProfileModal.css';

const SaveProfileModal = (props: { 
    submitEdit: () => void,
    startPasswordReset: () => void, 
    translate: () => void, 
    setShowSaveProfileModal: React.Dispatch<React.SetStateAction<boolean>> }) => {

    useEffect(() => {
        props.translate();
    }, []);

    const saveAndContinue = async () => {
        await props.submitEdit();
        props.startPasswordReset();
    }

    return (
        <div id="save-profile-modal">
            <form id="contact-form" className="off-white" action="javascript:void(0);">
                <div id="contact-head" className="align-center">
                    <h3 className="">Save changes?</h3>
                    <div id="close-contact" className="16a7fbb4-7e6d-4217-9d6c-dee7d73b425b" onClick={() => props.setShowSaveProfileModal(false)}>Close</div>
                </div>
                <div className="spacer hidden-xs"></div>
                <p>Would you like to save your profile changes before reseting your password?</p>
                <div className="spacer hidden-xs"></div>
                <div className="row">
                    <div className="col-sm-12">
                        <p>
                            <button className="" type="submit" style={{float: "right", margin: "5px"}} onClick={() => saveAndContinue()}>Save and continue</button>
                            <button className="" type="submit" style={{float: "right", margin: "5px"}} onClick={() => props.startPasswordReset()}>Continue without saving</button>
                            <button className="" type="submit" style={{float: "right", margin: "5px"}} onClick={() => {props.setShowSaveProfileModal(false)}}>Cancel</button>
                        </p>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default SaveProfileModal;